import React from 'react';

const PrivacyPolicy = () => (
  <div style={{ maxWidth: '680px', margin: '0 auto', padding: '40px 24px', fontFamily: 'Georgia, serif', color: '#ccd6f6', background: '#0a0e1a', minHeight: '100vh' }}>
    <div style={{ fontFamily: 'Oswald, sans-serif', fontSize: '28px', fontWeight: 700, color: '#cc0000', letterSpacing: '3px', marginBottom: '8px' }}>KNOW YOUR GUY</div>
    <div style={{ fontFamily: 'Oswald, sans-serif', fontSize: '13px', color: '#c9a84c', letterSpacing: '3px', marginBottom: '32px' }}>PRIVACY POLICY</div>
    <p style={{ fontSize: '13px', color: '#5a6a80', marginBottom: '32px' }}>Last updated: April 5, 2026</p>

    {[
      ['Information We Collect', 'We collect your email address and username when you create an account. If you sign in with Google, we receive your name and email from Google. We also collect gameplay data such as scores, streaks, and game history.'],
      ['How We Use Your Information', 'We use your information to operate the game, maintain leaderboards, send daily challenge reminder emails, and improve the experience. We do not sell your data to third parties.'],
      ['Email Communications', 'By creating an account, you may receive daily challenge reminders and game notifications. You can opt out by contacting us at matt@knowyourguy.com.'],
      ['Data Storage', 'Your data is stored securely using Supabase. We take reasonable measures to protect your information.'],
      ['Third-Party Services', 'We use Supabase for authentication and data storage, and Resend for email delivery. Google OAuth is available as a sign-in option.'],
      ['Contact', 'Questions? Reach us at matt@knowyourguy.com'],
    ].map(([title, body]) => (
      <div key={title} style={{ marginBottom: '28px' }}>
        <div style={{ fontFamily: 'Oswald, sans-serif', fontSize: '15px', color: '#c9a84c', letterSpacing: '2px', marginBottom: '8px', textTransform: 'uppercase' }}>{title}</div>
        <p style={{ fontSize: '15px', lineHeight: '1.8', margin: 0 }}>{body}</p>
      </div>
    ))}

    <div style={{ marginTop: '48px' }}>
      <a href="/" style={{ fontFamily: 'Oswald, sans-serif', fontSize: '13px', color: '#c9a84c', letterSpacing: '2px', textDecoration: 'none' }}>← BACK TO KNOW YOUR GUY</a>
    </div>
  </div>
);

export default PrivacyPolicy;
